<!--  -->
<template>
    <div>
        <template v-for="(item,index) in currentMenuItem.Children">
            <template v-if="!item.IsNest">
                <el-menu-item
                    :key="index"
                    :index="item.vueKey"
                    @click="menuItemClick(item)"
                >{{item.Title}}</el-menu-item>
            </template>
            <template v-if="item.IsNest">
                <el-submenu :index="item.vueKey" :key="index">
                    <template slot="title">{{item.Title}}</template>
                    <nav-bar-menu :currentMenuItem="item" @menu-item-click="menuItemClick"></nav-bar-menu>
                </el-submenu>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    name: 'nav-bar-menu',

    props: {
        currentMenuItem: Object,
    },
    mounted: function() {},
    methods: {
        menuItemClick(item) {
            this.$emit('menu-item-click', item);
        },
    },
};
</script>
<style lang='scss' scoped>
</style>